// extracted by mini-css-extract-plugin
export default {"brandSpectrum":"styles_brandSpectrum__SuLEI","brandSpectrum__colour":"styles_brandSpectrum__colour__pG322"};